import loadable from '@loadable/component';

export const CmsMobileTableOfContentsLoadable = loadable(
  () => import('./CmsMobileTableOfContents'),
  { resolveComponent: (module) => module.CmsMobileTableOfContents },
);
